import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {TrainingRoom} from "@models";

export interface DialogData_DetailedRoomSelectionInput extends MatDialogDataBaseInput {
	preselectedTrainingRooms: TrainingRoom[];
	singleRoom?: boolean;
	excludeRoomIds?: string[];
}

export interface DialogData_DetailedRoomSelectionOutput extends MatDialogDataBaseOutput {
	trainingRoomSelection?: TrainingRoom[];
}

@Component({
	selector: "sim-detailed-room-selection-dialog",
	templateUrl: "./detailed-room-selection-dialog.component.html",
	styleUrls: ["./detailed-room-selection-dialog.component.scss"],
	standalone: false,
})
export class DetailedRoomSelectionDialogComponent extends BasicMaterialDialog<
	DetailedRoomSelectionDialogComponent,
	DialogData_DetailedRoomSelectionInput,
	DialogData_DetailedRoomSelectionOutput
> {
	planView: boolean = false;

	constructor(_injector: Injector) {
		super(_injector);
	}

	protected selectTrainingRoom(trainingRoom: TrainingRoom) {
		if (this.data.singleRoom) {
			this.data.preselectedTrainingRooms = [trainingRoom];
		}
	}

	protected onRoomPlannerToggle(isPlanView: boolean) {
		this.planView = isPlanView;
	}
}
